import { Action, getModule, Mutation, VuexModule } from 'vuex-module-decorators'
import { AuthMethod } from '@/dto/AuthMethod'
import LoginService from '@/modules/login/services/LoginService'
import StorageHelper from '@/modules/login/helpers/StorageHelper'
import { PhoneHelper } from '@/modules/login/helpers/PhoneHelper'
import DynamicModule from '@/modules/login/stores/DynamicModule'
import User from '@/dto/User'
import { Notify } from 'quasar'
import UserService from '@/modules/login/services/UserService'

@DynamicModule
class LoginStore extends VuexModule {
  phone: string = ''
  authMethod: AuthMethod | null = null
  errors: { [key: string]: string } = {}

  get errorMessage(): string {
    const errorsWithoutIp = { ...this.errors }

    if ('ip' in errorsWithoutIp) {
      delete errorsWithoutIp.ip
    }

    if (Object.keys(errorsWithoutIp).length === 0) {
      return ''
    }

    return Object.values(errorsWithoutIp).join(' ')
  }

  get ipError(): string {
    return this.errors.ip || ''
  }

  get currentUser(): User | null {
    return StorageHelper.getUserByPhone(PhoneHelper.clearValue(this.phone))
  }

  @Mutation
  setPhone(phone: string) {
    this.phone = phone
    this.errors = {}
  }

  @Mutation
  setAuthMethod(authMethod: AuthMethod | null) {
    this.authMethod = authMethod
    this.errors = {}
  }

  @Mutation
  setErrors(errors: { [key: string]: string }) {
    this.errors = errors
  }

  @Action({ rawError: true })
  submitPhone() {
    return LoginService.getAuthMethodByPhone(this.phone)
      .then(authMethod => this.setAuthMethod(authMethod))
      .catch(error => {
        if (!error.response.data.errors) {
          Notify.create(
            'Неизвестная ошибка сервера, обратитесь к разработчикам!'
          )
        } else {
          this.setErrors(error.response.data.errors)
        }
      })
  }

  @Action({ rawError: true })
  login(password: string): Promise<string | void> {
    return LoginService.login(this.phone, password)
      .then(url => {
        return UserService.loadUser().then((user: User) => {
          StorageHelper.saveUser(user)

          return url
        })
      })
      .catch(error => {
        if (!error.response.data.errors) {
          Notify.create(
            'Неизвестная ошибка сервера, обратитесь к разработчикам!'
          )
        } else {
          this.setErrors(error.response.data.errors)
        }
      })
  }
}

export default getModule(LoginStore)
